var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhitelabelLogoHorizontal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "500 -235 784.93 373.08",
    width: 130,
    height: 42,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3 0 0 -3 0 373.08)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.1)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1549.6 1590.9c-77.87 0-121.86-65-121.86-190.86 0-125.85 45.92-192.75 123.85-192.75 77.99 0 121.97 64.94 121.97 190.8 0 126-45.97 192.81-123.96 192.81zm0-552.55c-189.79 0-322.68 126.89-322.68 359.74 0 232.87 134.83 361.76 324.67 361.76 189.88 0 322.83-126.93 322.83-359.81 0-232.75-135-361.69-324.82-361.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2276.2 1038.3c-207.83 0-318.85 153.84-318.85 360.74 0 224.86 132.04 360.76 319.83 360.76 171.74 0 239.92-73.93 287.83-205.84l-175.9-69.02c-25.04 65.03-49.04 105.91-112.91 105.91-80.96 0-115.92-80.88-115.92-191.81 0-106.98 33.95-191.8 117.93-191.8 61.02 0 86.88 32.95 124.91 98.89l163.84-86.96c-46.89-91.93-124.82-180.87-290.76-180.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2663.9 1049.3v699.53h535.67v-162.95h-343.84v-92.95h206.89v-160.88h-206.89v-119.86h350.81v-162.89h-542.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3667.4 1372.1c-25.02 89.88-35.93 127.98-44.96 175-9.02-47.02-19.92-86.04-44.96-175l-12.95-45.98h115.84zm97.93-322.74-37.93 122.91h-209.84l-38.05-122.91h-207.79l253.79 699.53h195.9l253.88-699.53h-209.96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4502.2 1049.3-166.9 230.82c-31.07 43.03-91.01 132.95-108.94 163.91 4.98-30.96 6.01-123.99 6.01-180.94v-213.79h-185.86v699.53h170.88l153.79-206.87c31.93-42.97 93.93-135.86 108.97-164.94-4.98 31.01-5.94 123.96-5.94 180.93v190.88h185.78v-699.53h-157.79"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitelabelLogoHorizontal);
export default __webpack_public_path__ + "static/media/WhitelabelLogoHorizontal.22cf38c6.svg";
export { ForwardRef as ReactComponent };